import React, { useState } from 'react';
import classNames from 'classnames';

import './ExpandDoc.scss';

function functionArgs(doc) {
    if (!doc)
        return "()";
    return "(" + Object.keys(doc).join(", ") + ")";
}

/**
 * Documentation with expandable recursive nested properties
 */
function ExpandDoc({
    method,
    doc
}) {

    if (doc == null || typeof doc !== 'object')
        throw new Error("error");

    return <div className="expand-doc">
        {method && <div className="method">
            {method}
            {functionArgs(doc)}
        </div>}
        {Object.keys(doc).map((name) => {
            const value = doc[name];
            return <Property key={name} name={name} value={value} depth={0} />
        })}
    </div>
}

/**
 * List of types
 */
function TypeList({
    type
}) {

    if (!Array.isArray(type))
        return type;

    return <ul>
        {type.map((v) => <li>{v}</li>)}
    </ul>
}

/**
 * Inner property documentation with expandable recursivea nested properties
 */
function Property({
    name, value, depth
}) {

    const [expanded, setExpanded] = useState(false);

    const field = <>
        <div className="head">
            <span className="label">
                {name}
            </span>: <span className="type">
                <TypeList type={value.type} />
                {value.type === 'function' && ' ' + functionArgs(value.children)}
                {value.mandatory && <span className="mandatory" title="Mandatory"> *</span>}
            </span>
        </div>
        {value.default && <div className="default"><span>Default:</span><span> <code>{value.default}</code></span></div>}
        <div className="description">
            {value.description}
        </div>
    </>;

    return <div className={classNames("property", {expanded: expanded, expandable: !!value.children, even: depth % 2 === 0})}>
        {value.children
            ? <>
                <div className="field" onClick={() => setExpanded(!expanded)}>
                    {field}
                </div>
                <div className="content">
                    {Object.keys(value.children).map((innerName) => {
                        const innerValue = value.children[innerName];
                        return <Property key={innerName} name={innerName} value={innerValue} depth={depth + 1} />
                    })}
                </div>
            </>
            : <div className="field">
                {field}
            </div>
        }
    </div>;
}

export default ExpandDoc;
